<template>
  <div class="delivery-methode-container">
    <div class="delivery-method-titles">{{ $translation($websiteText().checkout_delivery_method_delivery_method) }}</div>
    <div class="title-delivery-methode-info">
      {{ $translation($websiteText().checkout_delivery_method_sentence) }}
    </div>
    <div
      v-for="deliveryMethod in deliveryMethods"
      v-bind:key="deliveryMethod.id"
      class="info-address-methode-item p-field-radiobutton"
      v-bind:playwright-id="'delivery-method-'+deliveryMethod.id"
    >
      <RadioButton
        :id="deliveryMethod.id"
        :name="deliveryMethod.name"
        :value="deliveryMethod.id"
        :disabled="$store.getters.status_id!=1"
        v-model="methodSelected.value"
        @change="onChange(deliveryMethod)"
      />
      <label>
        <div class="description">
          <div class="title-methode-delivery">
            {{$translation(deliveryMethod.name) }}
          </div>
          <div class="description-methode-delivery">
            {{ $translation(deliveryMethod.description) }}
          </div>
        </div>
      </label>
    </div>
    <hr >

    <div style="margin-top: 35px;" v-if="showInsuranceCheckbox">
      <t-checkbox
        v-model="insuranceChecked"
        name="insurance"
        :label="$translation($websiteText().checkout_generals_insurance)"
        @change="toggleCheckox"
        :changeAction="updateInsurance"
        :disabled="$store.getters.status_id!=1"
      />
      <hr>
    </div>

    <template v-for="(coupon, index) in coupons" :key="index">
      <div style="display: flex;">
        <t-input-text
          v-model="coupons[index]"
          placeholder="enter coupon"
          type="text"
          :name="coupon"
          style="width: 100%;"
          :onInputText="onInput"
        />
        <div class="remove-class" @click="deleteCoupon(index)">x</div>
      </div>
    </template>
    <small v-if="this.showInlineErrorMessage" class="error-msg">
      {{ this.inlineErrorMessage }}
    </small>
    
    <div style="margin-top: 35px; display: flex;">
      <div>
        <TButton
          :label="coupons.length == 1 ?  $translation($websiteText().checkout_generals_apply_coupon_btn): $translation($websiteText().checkout_generals_apply_coupons_btn)"
          :color="'primary-color-medium'"
          @click="applyCoupons"
          :disabled="$store.getters.status_id!=1"
          style="margin-right: 20px;"
        ></TButton>
      </div>
      <TButton
        :label="'+ '+$translation($websiteText().checkout_generals_add_coupon_btn)"
        :color="'light-color2'"
        @click="addCoupon"
        style="height: 31px;"
      ></TButton>
    </div>
    <hr>

  
    <div style="margin-top:40px" class="delivery-method-titles">
      {{$translation($websiteText().checkout_payment_method_payment_method)}}
    </div>
    <payment />

  </div>
</template>
<script>
import { defineAsyncComponent } from 'vue'
const RadioButton = defineAsyncComponent(() =>
  import('primevue/radiobutton')
)
import payment from "./payment/Payment";
import {
  GET_PRICE_BREAKDOWN,
  GET_DELIVERY_METHODS,
  UPDATE_DELIVERY_METHOD,
  EDIT_ALL_ORDER_DETAILS,
  UPDATE_IS_BILLING,
  UPDATE_INSURANCE_PERCENTAGE
} from "../../store/actions";
import { reactive } from "@vue/reactivity";
import store from "../../../../store";
import TCheckbox from '../../../../common/components/controls/TCheckbox.vue';
import TButton from '../../../../common/components/buttons/TButton.vue';
import TInputText from '../../../../common/components/input-text/TInputText.vue';
import TInlineMessage from '../../../../common/components/messages/TInlineMessage.vue';
import CouponService from '../../../../common/services/checkout/CouponService';

let couponService = new CouponService()

export default {
  name: 'Delivery Method',
  components: { RadioButton, payment, TCheckbox, TButton, TInputText, 
  },
  data() {
    return {
      test: true,
      deliveryMethods: [],
      changeMethodEvent:null,
      display:false,
      insuranceChecked:false,
      inlineErrorMessage: "",
      showInlineErrorMessage:false,
      coupons: [],
      showInsuranceCheckbox: true
    };
  },
  mounted() {
    this.$store.dispatch(GET_DELIVERY_METHODS).then((res) => {
      this.deliveryMethods = res;
    });
    
    this.$store.getters.insurance_percentage > 0 ? this.insuranceChecked = true : this.insuranceChecked = false
    this.getOrderCoupons(this.$store.getters.orderId)
    window.scrollTo(0,0)
  },
  methods: {
    async onChange(deliveryMethod) {
      this.$store.commit(UPDATE_DELIVERY_METHOD, deliveryMethod.id);
      if(deliveryMethod.is_insured == 0){
        this.showInsuranceCheckbox = false
      }
      await this.$store.dispatch(EDIT_ALL_ORDER_DETAILS);
      await this.$store.dispatch(GET_PRICE_BREAKDOWN);
    },
    closeDialog()
    {
      this.display = false;
    },

    addCoupon(){
    
      if(this.coupons.length>0 && this.coupons[this.coupons.length-1].coupon == ""){
        this.inlineErrorMessage = "please enter your coupon"
        this.showInlineErrorMessage = true
      }
      else
        this.coupons.push("")
    },

    async applyCoupons()
    {
      await couponService.modifyOrderCoupons(
        {
          order_id: this.$store.getters.orderId,
          coupons: this.coupons
        }
      )
      await this.$store.dispatch(EDIT_ALL_ORDER_DETAILS);
      await this.$store.dispatch(GET_PRICE_BREAKDOWN);
    },

    async getOrderCoupons(order_id)
    {
      let results = await couponService.getOrderCoupons(order_id)
      this.coupons = results.data
      if(this.coupons.length == 0 ) this.addCoupon()
    },

    onInput(){
      this.showInlineErrorMessage = false
    },
    deleteCoupon(index){
      this.coupons.splice(index,1)
    },

    openDialog()
    {
      this.display = true;
    },
    toggleCheckox()
    {
      this.insuranceChecked = !this.insuranceChecked
     
    },
    async updateInsurance(){
      
      if(this.insuranceChecked) this.$store.commit(UPDATE_INSURANCE_PERCENTAGE, 1)
      else this.$store.commit(UPDATE_INSURANCE_PERCENTAGE, 0)
      await this.$store.dispatch(EDIT_ALL_ORDER_DETAILS);
      await this.$store.dispatch(GET_PRICE_BREAKDOWN);
     
    }

  },

  setup() {
    let methodSelected = reactive({ value: store.getters.orderDeliveryMethod });
    let insurance_percentage = store.getters.insurance_percentage
   
    const goToPayment = () => {
      store.commit(UPDATE_IS_BILLING,true);
      store.dispatch(EDIT_ALL_ORDER_DETAILS);

      store.commit('clearCart');
   
      store.commit("deliveryMethodSelected", methodSelected.value);
      store.commit("deliveryMethodeDisplayActive", false);
      store.commit("paymentDisplayActive", true);
      store.commit("checkoutActiveComponent", payment);
      store.commit("paymentDisplay", false);
      store.commit("displaySummery", true);
      store.commit("setStepperDisplays", [1, 1, 1, 1, 0, 0]);
    };
  
    return { goToPayment, methodSelected, insurance_percentage };
  },
};
</script>
<style lang="scss">
.btn-next {
  margin-top: 50px !important;
}

label {
  @include f-subtitle2;
}
@import "../../style/DeliveryMethode.scss";

.delivery-method-titles{
  color:$tertiary-color;
  @include f-subtitle2;
  margin-bottom: 25px;
}
.p-radiobutton .p-radiobutton-box.p-highlight {
  border-color: $primary-color;

}

.p-radiobutton .p-radiobutton-box .p-radiobutton-icon {
  
  background-color: $primary-color;

  
}

.remove-class {
  width: 26px;
  height: 26px;
  @include f-button;
  font-size: 20px;
  background: transparent;
  color: red;
  border: none;
  cursor: pointer;
  margin-left: 20px;
  align-self: center;
}

.error-msg {
  @include f-small;
  color: red;
}






</style>
